export default class PyramidBuilderService {
  constructor(apiService, $q, $state) {
    'ngInject';

    Object.assign(this, { apiService, $q, $state });

    this.store = {};
    this.inited = false;
  }

  init(title, scale) {
    if (this.inited) {
      const key = this.generateKey(title);
      if (!this.store[key]) {
        this.createPyramid(key, title, scale);
      } else {
        this.store[key].key = key;
      }
      return this.$q.resolve(this.store[key]);
    } else {
      return this.apiService
        .get({ url: '/api/v1/pyramids' })
        .then(data => {
          if (data.status === 403) {
            this.$state.go('auth.login');
            return;
          }
          this.inited = true;
          this.store = data.value;
          this.opacity = data.opacity;

          const key = this.generateKey(title);
          if (!this.store[key]) {
            this.createPyramid(key, title, scale);
          }
          return {...this.store[key], key};
        })
        .catch(error => {
          console.log(error);
        });
    }
  }

  save(opacity) {
    return this.apiService
      .patch({
        url: '/api/v1/pyramids',
        data: {
          pyramid: {
            value: this.store
          }
        }
      })
      .then(data => {});
  }

  createPyramid(key, title, scale) {
    this.store[key] = this.newPyramid(key, title, scale);
  }

  newPyramid(key, title, scale) {
    let zoom = {
      k: scale,
      x: 60,
      y: 10,
    };

    if (scale.k) zoom = scale;

    return {
      title,
      key,
      guid: this.guid(),
      pyramid: {
        active: true,
        question: {
          active: false
        },
        zoom: zoom,
        number: 0,
        scheme: [
          {
            model: null,
            children: [
              {
                model: null,
                children: []
              },
              {
                model: null,
                children: []
              },
              {
                model: null,
                children: []
              }
            ]
          }
        ]
      },
      scq: {
        active: false
      },
      problemDefinition: {
        active: false,
        secondLayer: {
          active: false
        }
      }
    };
  }

  // updatePyramidSchemeByAmount(parentScheme, amount = 1, maxChildrenPerRow = 4) {
  //     if (parentScheme.children.length > amount) {
  //         for (let j = parentScheme.children.length - 1; j >= amount; j--) {
  //             parentScheme.children.splice(j, 1);
  //         }
  //     } else {
  //         for (let j = 0; j < amount; j++) {
  //             if (!parentScheme.children[j]) {
  //                 parentScheme.children.push({
  //                     model: null,
  //                     children: []
  //                 });
  //             }
  //         }
  //     }
  //     return parentScheme;
  // }

  // generatePyramidSchemeByAmount(parentScheme, amount = 1, maxChildrenPerRow = 4) {
  //     const maxRows = Math.ceil(amount / maxChildrenPerRow);
  //
  //     let scheme = [{
  //         model: null,
  //         children: []
  //     }];
  //
  //     for (let i = 0, children = scheme[0].children; i < maxRows; i++) {
  //         let restAmount = amount - maxChildrenPerRow * i;
  //         let maxCells = restAmount > maxChildrenPerRow
  //             ? maxChildrenPerRow
  //             : Math.abs(restAmount) - 1;
  //
  //         for (let j = 0; j < maxCells; j++) {
  //             children[j] = {
  //                 model: null,
  //                 children: []
  //             };
  //         }
  //
  //         //let midIndex = Math.floor(children.length * 0.5);
  //
  //         //if (!children[midIndex]) break;
  //
  //         children = children[0].children;
  //     }
  //
  //     return scheme;
  // }

  deletePyramid(key) {
    delete this.store[key];
  }

  generateKey(title) {
    return title.replace(/^([A-Z])|\s(\w)/g, function(match, p1, p2, offset) {
      if (p2) return p2.toUpperCase();
      return p1.toLowerCase();
    });
  }

  guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }
}



// WEBPACK FOOTER //
// ./client/app/services/pyramidBuilder.service.js